module.exports = __webpack_public_path__ + "static/media/fiets2.0.35b5c3af.png";